import { api } from "../../../../utils/api";

export const getFunnelWithStatus = async (id) => {
    try {
        const response = await api.get(`/funnel${id ? `/${id}` : ""}`);
        return response.data;
      } catch (error) {
        throw error;
      }
}